import { SupportedSourceLanguages } from './languages';

export enum PostMessageEvent {
  ClickPause = 'click-pause',
  FocusTranslation = 'focus-translation',
  BlurTranslation = 'blur-translation',
  ClickSaveWord = 'click-save-word',
  ClickOpenSettings = 'click-open-settings',
  ClickIKnowThis = 'click-i-know-this',
  QuizEnter = 'quiz-enter',
  QuizExit = 'quiz-exit',
  PinTranslation = 'pin-translation',
  MountTranslation = 'mount-translation',
  CloseHover = 'close-hover',
  RemoveTranslations = 'remove-translations',
  CrawlPage = 'crawl-page',
  ReactivateTranslations = 'reactivate-translations',
  ChangeLanguage = 'change-language',
  UpdateDifficultyTier = 'update-difficulty-tier',
  SupportsDifficulty = 'supports-difficulty',
  MessageListenerReady = 'message-listener-ready',
  ExtensionInformationRequest = 'extension-information-request',
  ExtensionInformationResponse = 'extension-information-response',
}
export interface PostMessageData {
  type: PostMessageEvent;
  translationInfo: {
    id: string;
    translationId: string;
    word: string;
    targetPhrase: string;
    // placeholder values
    isKnown: boolean;
    progressionScore: number;
    isSaved: boolean;
    source: string;
  };
  sourceLanguageId?: SupportedSourceLanguages;
  difficultyTier?: string;
}
